import { Button } from 'primereact/button';

interface RefreshButtonProps {
  onClick: () => void;
  loading?: boolean;
  testId?: string;
  className?: string;
}

export const RefreshButton = ({ onClick, loading = false, testId, className }: RefreshButtonProps) => (
  <Button
    // A <button> inside a <form> submits it unless told otherwise. This one sits
    // in toolbars that are sometimes inside forms (a pipeline's Sources tab is
    // rendered in the pipeline form), where a refresh used to SAVE the form.
    type="button"
    icon={`pi pi-refresh ${loading ? 'pi-spin' : ''}`}
    rounded
    text
    severity="info"
    onClick={onClick}
    disabled={loading}
    data-testid={testId}
    className={className}
    tooltip="Refresh"
    tooltipOptions={{ position: 'top' }}
  />
);

export default RefreshButton;
